import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/ImageCarousel.css";

// Import images for carousel
import karigar from "../assets/karigar.jpg";
import darkImage from "../assets/dark.jpg";
import falseCeilingImage from "../assets/false_cieling.jpg";
import work from "../assets/work.jpg";
import bedroom2 from "../assets/bedroom2.jpg";

// Import images for service cards
import office from "../assets/office.jpg";
import library from "../assets/work.jpg";
import officeCeiling from "../assets/office_ceiling.jpg";
import publicImage from "../assets/public.jpg";
import background from "../assets/background.jpg";

const ImageCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const slides = [
    {
      id: 1,
      image: karigar,
      alt: "Karigar"
    },
    {
      id: 2,
      image: darkImage,
      alt: "Premium Dark Finishes"
    },
    {
      id: 3,
      image: falseCeilingImage,
      alt: "False Ceiling Specialists"
    },
    {
      id: 4,
      image: work,
      alt: "Multiple Options"
    },
    {
      id: 5,
      image: bedroom2,
      alt: "Modern Designs"
    }
  ];

  const serviceCards = [
    {
      id: 1,
      image: office,
      title: "Elegant POP Sculpted Ceiling",
      description: "Gracefully sculpted POP ceilings that elevate every room with timeless elegance and modern finesse.",
      link: "/service/1"
    },
    {
      id: 2,
      image: library,
      title: "Precision Gypsum Panel Ceiling",
      description: "Precision‑cut gypsum panels for seamless ceilings that enhance acoustics, lighting, and modern aesthetics.",
      link: "/service/2"
    },
    {
      id: 3,
      image: officeCeiling,
      title: "Modern Louvered Wall Panels",
      description: "Sleek louvered wall panels that blend texture, ventilation, and modern elegance for a refined architectural statement.",
      link: "/service/3"
    },
    {
      id: 4,
      image: publicImage,
      title: "AquaShield Moisture-Guard Ceiling",
      description: "Seal out humidity with a waterproof, mildew‑resistant ceiling built for kitchens, baths, and balconies.",
      link: "/service/4"
    },
    {
      id: 5,
      image: background,
      title: "Laminated False Ceiling",
      description: "Seamless laminated panels that deliver modern aesthetics, quick installation, and a wipe‑clean, long‑lasting surface.",
      link: "/service/5"
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length, isHovered]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="carousel-section">
      {/* Image-only Carousel - COMMENTED OUT
      <div className="carousel-container">
        <div 
          className="carousel-wrapper"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="carousel-slides" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {slides.map((slide) => (
              <div key={slide.id} className="carousel-slide">
                <div className="slide-content">
                  <img src={slide.image} alt={slide.alt} />
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-nav prev" onClick={prevSlide}>
            &#8249;
          </button>
          <button className="carousel-nav next" onClick={nextSlide}>
            &#8250;
          </button>

          <div className="carousel-dots">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
      */}

      {/* Service Cards Section */}
      <div className="service-cards-container">
        <h2 className="section-heading">Our Services</h2>
        <div className="service-cards">
          {serviceCards.map((card) => (
            <div key={card.id} className="service-card">
              <div className="card-image">
                <img src={card.image} alt={card.title} />
              </div>
              <div className="card-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <Link to={card.link}>
                  <button className="card-button">Learn More</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Reasons to Love Section */}
      <div className="reasons-container">
        <h2 className="section-heading">Reasons to love Get Karigar</h2>
        <div className="reasons-grid">
          <div className="reason-tile">
            <div className="reason-icon">
              <span>💰</span>
            </div>
            <h3>Saves Time and Money</h3>
            <p>Saves time and money with verified professionals.</p>
          </div>
          <div className="reason-tile">
            <div className="reason-icon">
              <span>📱</span>
            </div>
            <h3>Hassle-Free Service</h3>
            <p>Hassle-free booking and project management.</p>
          </div>
          <div className="reason-tile">
            <div className="reason-icon">
              <span>✓</span>
            </div>
            <h3>Quality Guaranteed</h3>
            <p>Guaranteed quality workmanship and on-time delivery.</p>
          </div>
          <div className="reason-tile">
            <div className="reason-icon">
              <span>🏢</span>
            </div>
            <h3>All Space Types</h3>
            <p>Suitable for residential, retail, commercial, and office spaces.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
